// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SOOrderItemRequests_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /so/order_item_requests/remover
 *
 * Removes a service-order order item request by ID.
 */
import { registerContract } from './validate'

export interface SOOrderItemRequests_RemoverInput {
id: number
}

registerContract('SOOrderItemRequests_RemoverInput', {
  id: { type: 'number',  required: true },
})
